import React, { useState, useRef, useEffect } from 'react';
import './gridImageView..css'
import { motion } from 'framer-motion';
import { useLocation } from 'react-router';

function C2wGridImageView() {
  const [activeIndex, setActiveIndex] = useState(0)
  const [videoFlag, setVideoFlag] = useState(false)
  const videoRef = useRef(null)
  const [isPlaying, setIsPlaying] = useState(false);
  const location = useLocation()
  const flag = location.state

  const superxTestimonials = [
    { id: 1, name: 'AppBuilders', videoId: 'Vtyhv1QFVy0', subtitle: 'Flutter 2024' },
    { id: 2, name: 'EPnchayat', videoId: 'scadJFjx_qE', subtitle: 'Flutter 2024' },
    { id: 3, name: 'EPnchayat', videoId: 'tfyGdW8K2OE', subtitle: 'Flutter 2024' },
    { id: 4, name: 'EPnchayat', videoId: 'cUqcLGke0tM', subtitle: 'Flutter 2024' },
    { id: 5, name: 'EPnchayat', videoId: 'Ni9e8wXdIKQ', subtitle: 'Flutter 2024' },
    { id: 6, name: 'EPnchayat', videoId: '3ZncLRA0diA', subtitle: 'Flutter 2024' },
    { id: 7, name: 'EPnchayat', videoId: '-dTwEDYxuwI', subtitle: 'Flutter 2024' },
    { id: 8, name: 'EPnchayat', videoId: 'AEOOc3dKvaU', subtitle: 'Flutter 2024' },
    { id: 9, name: 'EPnchayat', videoId: 'kh55vv3ocAM', subtitle: 'Flutter 2024' },
    { id: 10, name: 'EPnchayat', videoId: 'b9FDVIZzF4k', subtitle: 'Flutter 2024' },
    { id: 11, name: 'EPnchayat', videoId: 'aqXrDAytqZo', subtitle: 'Flutter 2024' },
    { id: 12, name: 'EPnchayat', videoId: 'TwzsC_UaB9M', subtitle: 'Flutter 2024' },
    { id: 13, name: 'EPnchayat', videoId: '6rKYD4W5U1Q', subtitle: 'Flutter 2024' },
    { id: 14, name: 'EPnchayat', videoId: 'bjAzSZXOAqg', subtitle: 'Flutter 2024' },
    { id: 15, name: 'EPnchayat', videoId: 'ZjE7hKmnEIk', subtitle: 'Flutter 2024' },
    { id: 16, name: 'EPnchayat', videoId: 'WVGqByaAfg4', subtitle: 'Flutter 2024' },
    { id: 17, name: 'EPnchayat', videoId: 'P-7cxOSCtRc', subtitle: 'Flutter 2024' },
    { id: 18, name: 'EPnchayat', videoId: 'ujhc5te9oAA', subtitle: 'Flutter 2024' },
    { id: 19, name: 'EPnchayat', videoId: 'cgVhS86p2LQ', subtitle: 'Flutter 2024' },
    { id: 20, name: 'EPnchayat', videoId: '34ghrHASIf0', subtitle: 'Flutter 2024' },
    { id: 21, name: 'EPnchayat', videoId: 'kFhfAZBWY2U', subtitle: 'Flutter 2024' },
    { id: 22, name: 'EPnchayat', videoId: 'af8cwe1dHfI', subtitle: 'Flutter 2024' }
  ];

  const homeTestimonials = [
    { id: 1, name: 'AppBuilders', videoId: 'gLOT3NZzLb8', subtitle: 'Flutter 2024' },
    { id: 2, name: 'EPnchayat', videoId: 'YZIp89cAIsc', subtitle: 'Flutter 2024' },
    { id: 3, name: 'EPnchayat', videoId: 'Drecs4K8kWU', subtitle: 'Flutter 2024' },
    { id: 4, name: 'EPnchayat', videoId: 'tfyGdW8K2OE', subtitle: 'Flutter 2024' },
    { id: 5, name: 'EPnchayat', videoId: 'cUqcLGke0tM', subtitle: 'Flutter 2024' },
    { id: 6, name: 'EPnchayat', videoId: 'Ni9e8wXdIKQ', subtitle: 'Flutter 2024' },
    { id: 7, name: 'EPnchayat', videoId: '3ZncLRA0diA', subtitle: 'Flutter 2024' },
    { id: 8, name: 'EPnchayat', videoId: '-dTwEDYxuwI', subtitle: 'Flutter 2024' },
    { id: 9, name: 'EPnchayat', videoId: 'AEOOc3dKvaU', subtitle: 'Flutter 2024' },
    { id: 10, name: 'EPnchayat', videoId: 'kh55vv3ocAM', subtitle: 'Flutter 2024' },
    { id: 11, name: 'EPnchayat', videoId: 'b9FDVIZzF4k', subtitle: 'Flutter 2024' },
    { id: 12, name: 'EPnchayat', videoId: 'aqXrDAytqZo', subtitle: 'Flutter 2024' },
    { id: 13, name: 'EPnchayat', videoId: 'TwzsC_UaB9M', subtitle: 'Flutter 2024' },
    { id: 14, name: 'EPnchayat', videoId: '6rKYD4W5U1Q', subtitle: 'Flutter 2024' },
    { id: 15, name: 'EPnchayat', videoId: 'bjAzSZXOAqg', subtitle: 'Flutter 2024' },
    { id: 16, name: 'EPnchayat', videoId: 'ZjE7hKmnEIk', subtitle: 'Flutter 2024' },
    { id: 17, name: 'EPnchayat', videoId: 'WVGqByaAfg4', subtitle: 'Flutter 2024' },
    { id: 18, name: 'EPnchayat', videoId: 'P-7cxOSCtRc', subtitle: 'Flutter 2024' },
    { id: 19, name: 'EPnchayat', videoId: 'ujhc5te9oAA', subtitle: 'Flutter 2024' },
    { id: 20, name: 'EPnchayat', videoId: 'cgVhS86p2LQ', subtitle: 'Flutter 2024' },
    { id: 21, name: 'EPnchayat', videoId: '34ghrHASIf0', subtitle: 'Flutter 2024' },
    { id: 22, name: 'EPnchayat', videoId: 'kFhfAZBWY2U', subtitle: 'Flutter 2024' },
    { id: 23, name: 'EPnchayat', videoId: 'af8cwe1dHfI', subtitle: 'Flutter 2024' }
  ];

  const testimonials = flag === 1 ? homeTestimonials : superxTestimonials;



  /** 
 * @hook useEffect - Outside Click Handler
 * @author Vishal Lohbande
 * @description Adds an event listener on the document to detect clicks outside the popup referenced by `popRef`.
 * When a click occurs outside the popup, it sets `setPopUpFlag` to false, effectively closing the popup.
 * Cleans up the event listener on component unmount.
 * 
 * Usage:
 * Useful for closing modals, dropdowns, or popups when clicking outside their bounds.
 */
  useEffect(() => {
    function handleOutsideClick(event) {
      if (videoRef && videoRef.current && !videoRef.current.contains(event.target)) {
        setVideoFlag(false)
        setIsPlaying(false)
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
    }
  }, [])

  const handlePlayPause = () => {
    if (videoRef.current) {
      const video = videoRef.current.querySelector('video');
      if (video) {
        if (video.paused) {
          video.play();
          setIsPlaying(true);
        } else {
          video.pause();
          setIsPlaying(false);
        }
      }
    }
  };


  /**
   * @constant windowWidth
   * @author Vishal Lohbande
   *
   * Description:
   * - Tracks the current width of the browser window.
   * - Initializes `windowWidth` with `window.innerWidth`.
   * - Uses `useEffect` to listen for window resize events and update the state accordingly.
   * - Cleans up the event listener on component unmount.
   *
   * Usage:
   * - Useful for implementing responsive designs based on screen width.
   *
   * Notes:
   * - Ensure this code runs only on the client-side, as `window` is undefined on the server.
   */
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);

    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [selectedSrc, setSelectedSrc] = useState('')

  return (
    <div className='C2wGridImageView_ctn'>
      {testimonials.map((obj, i) => (
        <div className='C2wGridImageView_ctn_videoHolder' onClick={() => {
          setVideoFlag(true)
          setIsPlaying(true)
          handlePlayPause()
          setSelectedSrc(`https://www.youtube.com/embed/${obj?.videoId}?enablejsapi=1&rel=0&modestbranding=1`)
        }}>
          <iframe
            src={`https://www.youtube.com/embed/${obj?.videoId}?enablejsapi=1&rel=0&modestbranding=1`}
            frameBorder="0"
            allow="encrypted-media"
            allowFullScreen
            style={{ width: '100%', height: '100%', borderRadius: '30px' }}
            modestbranding="1"
          ></iframe>
          <div className="overlay">
            <div className="info">
                {/* <h3>{obj.name}</h3>
                <p>{obj.subtitle}</p> */}
            </div>
            <div className='play-button_holder_outer'>
              <div className='play-button_holder_inner'>
                <div className="play-button">
                  <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.86285 2.59757C6.54158 1.85064 4.90625 2.80411 4.90625 4.32117V13.9362C4.90625 15.4538 6.54271 16.4079 7.86342 15.6592L16.3496 10.8506C17.689 10.0918 17.6884 8.16221 16.3496 7.40396L7.86285 2.59757Z" fill="white" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      {videoFlag &&
        <div className='C2wGridImageView_absolute' >
          <motion.div
            className='C2wGridImageView_absolute_motionvideo'
            onClick={handlePlayPause}
            ref={videoRef}
            layout
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0, duration: 0.5, ease: "easeOut" }}
          >
            <iframe
              className="C2wTestimonialsMobileCoverflowv_swiperSlide_video_div"
              src={selectedSrc}
              frameBorder="0"
              allow="autoplay"
              allowFullScreen
              modestbranding="1"
              style={{ width: '100%', height: '100%', borderRadius: '30px' }}
            ></iframe>

            {/* {!isPlaying && (
              <div className='play-button_holder_outer'>
                <div className='play-button_holder_inner'>
                  <div className="play-button">
                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.86285 2.59757C6.54158 1.85064 4.90625 2.80411 4.90625 4.32117V13.9362C4.90625 15.4538 6.54271 16.4079 7.86342 15.6592L16.3496 10.8506C17.689 10.0918 17.6884 8.16221 16.3496 7.40396L7.86285 2.59757Z" fill="white" />
                    </svg>
                  </div>
                </div>
              </div>
            )} */}
          </motion.div>

          <motion.div
            className='C2wGridImageView_absolute_motionvideo_info'
            layout
            initial={{ x: windowWidth > 620 ? -100 : 0, scale: 0, opacity: 0 }}
            animate={{ x: windowWidth > 620 ? 40 : 0, scale: 1, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5, ease: "easeOut" }}
          >
            {/* <span>{'Team: '}</span>{'Thunder bolt'} */}
          </motion.div>
        </div>
      }
    </div>
  )
}

export default C2wGridImageView;
